import { loader } from 'graphql.macro';

export const MUTATION_ROUTER_TRIGGER_ACTION = loader(
  './routerTriggerAction.graphql',
);
export const MUTATION_ROUTER_TRIGGER_GO_TO = loader(
  './routerTriggerGoTo.graphql',
);
